import React, { Fragment, useState } from "react";
import dayjs from "dayjs";
import { makeStyles, styled } from "@mui/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import utils from "../../../../utils";

const StyledRoot = styled("div")({});

const StyledTableRow = styled(TableRow)({
  "&.head": {
    backgroundColor: "#46cbe2",
    "& .MuiTableCell-head": {
      color: "#FFFFFF",
    },
  },
  "& .MuiTableCell-root": {
    height: 20,
    border: "1px solid #e0e0e0",
    "&.cell-data": {
      borderBottom: "none",
      borderTop: "none",
    },
  },
  "&:last-child": {
    "& .MuiTableCell-root": {
      borderBottom: "1px solid #e0e0e0",
    },
  },
});

const StyledTableRowSummary = styled(TableRow)({
  "&.total": {
    backgroundColor: "#EEEEEE",
  },
  "&.sum": {
    "& .net": {
      fontSize: 16,
      fontWeight: 500,
      backgroundColor: "#e0e0e0",
    },
    "& .blank": {
      borderBottom: "none",
      borderLeft: "none",
    },
  },
  "& .MuiTableCell-root": {
    border: "1px solid #e0e0e0",
  },
});

const StyledYearSummary = styled("div")({
  marginTop: 32,
  "& .head, .cell": {
    border: "1px solid #e0e0e0",
  },
  "& .cell": {
    fontSize: 18,
    fontWeight: 500,
  },
});

function TableSlip(props) {
  const { currentSlip } = props
  

  return (
    <StyledRoot>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <StyledTableRow className="head">
              <TableCell align="left">รายการเงินได้</TableCell>
              <TableCell align="right" style={{ width: 120 }}>
                จำนวนเงิน (บาท)
              </TableCell>
              <TableCell align="left">รายการเงินหัก</TableCell>
              <TableCell align="right" style={{ width: 120 }}>
                จำนวนเงิน (บาท)
              </TableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {[...Array(12).keys()].map((index) => (
              <StyledTableRow>
                <TableCell className="cell-data">
                  {currentSlip.addition[index] &&
                    `${currentSlip.addition[index].name} ${currentSlip.addition[index].payroundText}`}
                </TableCell>
                <TableCell align="right" className="cell-data">
                  {currentSlip.addition[index] &&
                    utils.numberWithCommas(currentSlip.addition[index].value)}
                </TableCell>
                <TableCell className="cell-data">
                  {currentSlip.deduction[index] &&
                    currentSlip.deduction[index].name}
                </TableCell>
                <TableCell align="right" className="cell-data">
                  {currentSlip.deduction[index] &&
                    utils.numberWithCommas(
                      currentSlip.deduction[index].value
                    )}
                </TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
          <StyledTableRowSummary className="total">
            <TableCell align="left">รวมเงินได้</TableCell>
            <TableCell align="right">
              {utils.numberWithCommas(currentSlip.totalEarnings)}
            </TableCell>
            <TableCell align="left">รวมเงินหัก</TableCell>
            <TableCell align="right">
              {utils.numberWithCommas(currentSlip.totalDeductions)}
            </TableCell>
          </StyledTableRowSummary>
          <StyledTableRowSummary className="sum">
            <TableCell colspan={2} className="blank"></TableCell>
            <TableCell align="left" className="net">
              จ่ายสุทธิ
            </TableCell>
            <TableCell align="right" className="net">
              {utils.numberWithCommas(currentSlip.net)}
            </TableCell>
          </StyledTableRowSummary>
        </Table>
      </TableContainer>
      <StyledYearSummary>
        <Typography gutterBottom>{`รายได้สะสม - ปี ${dayjs(
          currentSlip.monthPeriod
        ).format("BBBB")}`}</Typography>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell align="center" className="head">
                  เงินได้สะสม (บาท)
                </TableCell>
                <TableCell align="center" className="head">
                  ภาษีหัก ณ ที่จ่ายสะสม (บาท)
                </TableCell>
                <TableCell align="center" className="head">
                  ประกันสังคมสะสม (บาท)
                </TableCell>
                <TableCell align="center" className="head">
                  กองทุนสำรองเลี้ยงชีพสะสม (บาท)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="center" className="cell">
                  {utils.numberWithCommas(currentSlip.accumulateEarnings)}
                </TableCell>
                <TableCell align="center" className="cell">
                  {utils.numberWithCommas(currentSlip.accumulateTax)}
                </TableCell>
                <TableCell align="center" className="cell">
                  {utils.numberWithCommas(currentSlip.accumulateSSO)}
                </TableCell>
                <TableCell align="center" className="cell">
                  {utils.numberWithCommas(currentSlip.accumulatePF)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </StyledYearSummary>
    </StyledRoot>
  );
}

export default TableSlip;
